import { createApiActions } from '@tabeeb/shared/utils/actions'

export const getDefaultChatBot = createApiActions('GET_DEFAULT_CHAT_BOT')
